import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'component-library';
import { useTranslation } from 'react-i18next';

import { WidgetConfiguration } from '@/api/rest/resources/types/widget';
import { usePostWidgetConfiguration } from '@/api/rest/resources/widget';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

export const useEditWidgetConfiguration = () => {
  const { t } = useTranslation();
  const organizationId = useOrganizationId();
  const postMutation = usePostWidgetConfiguration();

  const queryClient = useQueryClient();

  const submit = async (configuration: WidgetConfiguration) => {
    try {
      await postMutation.mutateAsync({
        pathVariables: { organization_id: organizationId },
        bodyData: configuration,
      });

      toast({
        type: 'success',
        title: t('shared.customizeLayout.toasts.success.title'),
      });

      queryClient.invalidateQueries({
        queryKey: ['dashboard', 'widget', 'configuration', organizationId],
      });
    } catch (error) {
      toast({
        type: 'error',
        title: t('shared.customizeLayout.toasts.error.title'),
      });
    }
  };

  const isSubmitting = postMutation.isPending;

  return { submit, isSubmitting };
};
